import {
    Message,
    MessageBox
} from 'element-ui';

var messageInstance = false;
var messageBoxInstance = false; //公共弹框

const popup = {};

popup.showMessage = function (message = "", type = "success", duration = 2000, callback = () => {}) {
    if (!messageInstance) {
        Message({
            type: type,
            message: message,
            duration: duration,
            onClose: () => {
                messageInstance = false;
                callback();
            }
        })
        messageInstance = true;
    }
}

popup.showMessageBox = function (title = "提示", message = "", cancelButtonText = "取消", confirmButtonText = "确定", callback = () => {}, dangerouslyUseHTMLString = false) {
    if (!messageBoxInstance) {
        MessageBox({
            title: title, //MessageBox 标题
            message: message, //MessageBox 消息正文内容
            dangerouslyUseHTMLString: dangerouslyUseHTMLString,
            customClass: "mbs_showMessageBox",
            callback: (action) => {
                messageBoxInstance = false;
                callback(action)
            },
            showCancelButton: true,
            showConfirmButton: true,
            cancelButtonText: cancelButtonText,
            confirmButtonText: confirmButtonText,
            cancelButtonClass: "mbs_showMessageBox_cancel",
            confirmButtonClass: "mbs_showMessageBox_ok"
        })
    }
}

export default popup;